import { env } from 'env';
/**
 * Alert Payload Transformers
 *
 * Utility functions to transform alert payloads for MongoDB and Elasticsearch compatibility.
 * These transformers fix the payload structure to work with backend requirements.
 */

/**
 * Transforms Elasticsearch _source from string array to object array format.
 *
 * Backend requires object array format for proper field aliasing and extraction.
 *
 * @param fieldPaths - Array of field paths in dot notation
 * @returns Array of objects with field path as key and alias as value
 *
 * @example
 * // Input
 * ['pepwise.body.Project_Id', 'pepwise.body.metric.status']
 *
 * // Output
 * [
 *   {'pepwise.body.Project_Id': 'Project_Id'},
 *   {'pepwise.body.metric.status': 'status'}
 * ]
 */
export const buildElasticsearchSourceFields = (fieldPaths: string[]): Array<Record<string, string>> => {
    return fieldPaths.map(fieldPath => {
        const alias = fieldPath.split('.').pop() || fieldPath;
        return { [fieldPath]: alias };
    });
};

/**
 * Converts dot notation to nested object structure for MongoDB queries.
 *
 * MongoDB interprets dots in keys as nested path traversal, not literal keys.
 * This function converts dot-notated keys to proper nested object structure.
 *
 * @param dotPath - Field path in dot notation (e.g., 'pepwise.body.Project_Id')
 * @param value - The value to assign to the nested field
 * @returns Nested object structure
 *
 * @example
 * // Input
 * convertDotNotationToNested('pepwise.body.Project_Id', {$in: ['id1', 'id2']})
 *
 * // Output
 * {
 *   pepwise: {
 *     body: {
 *       Project_Id: {$in: ['id1', 'id2']}
 *     }
 *   }
 * }
 */
export const convertDotNotationToNested = (dotPath: string, value: any): any => {
    const parts = dotPath.split('.');
    const result: any = {};

    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
        current[parts[i]] = {};
        current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = value;

    return result;
};

export const getEnv = () => {
    if(env.REACT_APP_IS_DEV){
        return 'dev'
    }else if(env.REACT_APP_IS_QA){
        return 'qa'
    }else if(env.REACT_APP_IS_PREPROD){
        return 'preprod'
    }else if(env.REACT_APP_IS_PROD){
        return 'prod'
    }else{
        return 'qa'
    }
}